








































































































































































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import _, { cloneDeep } from 'lodash';
import { Refs } from '@/types';
import { ValidationRule } from '@cnamts/vue-dot/src/rules/types';
import { requiredFn } from '@cnamts/vue-dot/src/rules/required';
import { numericControl, nameControlParamDelegation } from '@/services/textInputControl';
import MixinVaccinationRules from '@/mixins/MixinVaccinationRules';
import { notAfterDate } from '@/rules/notAfterDate';
import { notBeforeDate } from '@/rules/notBeforeDate';
import { isDateValidFn } from '@cnamts/vue-dot/src/rules/isDateValid';
import { SaisieInfosPatientType } from './types';
import dayjs from 'dayjs';
import { formatDateISO, formatDateStandard } from '@/services/dateFormatter';

const DATE_NON_VALIDE = 'La date n’est pas valide.';
const CHAMP_OBLIGATOIRE = 'Ce champ est obligatoire.';

const Props = Vue.extend({
	props: {
		nir: {
			type: String,
			default: ''
		},
		infosPatient: {
			type: Object as () => SaisieInfosPatientType,
			default: undefined
		},
		disabled: {
			type: Boolean,
			default: false
		}
	}
});

@Component
export default class SaisieInfosPatient extends mixins(MixinVaccinationRules, Props) {
	$refs!: Refs<{
		infosPatientForm: HTMLFormElement;
	}>;

	labelAide = 'Mettre 1 systématiquement sauf pour les jumeaux ou triplés, mettre 1 à la première personne, 2 à son jumeau, 3 à son triplé.';

	nameControl = nameControlParamDelegation;
	numControl = numericControl;
	allowValidation = false;
	disableAutocompleteValue = this.autoCompleteStringValue();

	informationsPatient: SaisieInfosPatientType = {
		nir: this.nir,
		sexeBeneficiaire: ['1' , '2'].includes(this.nir.charAt(0)) ? this.nir.charAt(0) : '',
		nomUsage: '',
		nomFamille: '',
		prenom: '',
		rang: '1',
		dateNaissance: ''
	};

	listSexes = [
		{ text: 'Masculin', value: '1' },
		{ text: 'Féminin', value: '2' }
	];
	today = formatDateISO(dayjs());
	dateMin = formatDateISO(dayjs('01/01/1900'));

	requiredfield: ValidationRule[] = [
		requiredFn({ default: CHAMP_OBLIGATOIRE })
	];

	datePickerVaccinationRules: ValidationRule[] = [
		isDateValidFn({
			default: DATE_NON_VALIDE,
			wrongFormat: DATE_NON_VALIDE,
			monthNotMatch: '',
			notALeapYear: ''
		}),
		notAfterDate(formatDateStandard(dayjs()), { default: DATE_NON_VALIDE }),
		requiredFn({ default: CHAMP_OBLIGATOIRE }),
		notBeforeDate(formatDateStandard(dayjs('01/01/1900')), { default: DATE_NON_VALIDE })
	];

	get isEmergencyMode() {
		return _.isEmpty(this.nir);
	}
	validerSaisiePatientForm(): Promise<boolean> {
		return new Promise((resolve, reject) => {
			Promise.all([
				this.allowValidation = true,
				this.informationsPatient.nomFamille = this.informationsPatient.nomFamille?.toUpperCase(),
				this.informationsPatient.nomUsage = this.informationsPatient.nomUsage?.toUpperCase(),
				this.informationsPatient.prenom = this.informationsPatient.prenom?.toUpperCase()
			]).then(() => {
				resolve(this.$refs.infosPatientForm.validate());
			});
		});
	}

	getInfosPatient() {
		return this.informationsPatient;
	}

	created() {
		if (this.infosPatient) {
			this.informationsPatient = cloneDeep(this.infosPatient);
			this.informationsPatient.nir = this.nir;
		}
	}

	reset() {
		this.$refs.infosPatientForm.reset();
	}

	isChrome(): boolean {
		const globalAny: any = global;
		return !!globalAny.window.chrome && (!!globalAny.window.chrome.webstore || !!globalAny.window.chrome.runtime);
	}

	autoCompleteStringValue() {
		return this.isChrome() ? 'off' : 'nope';
	}
}
